import {
  CATEGORIES_REQUEST, CATEGORIES_REQUEST_SUCCESS, CATEGORIES_REQUEST_FAILED,
  CATEGORIES_ADD_ROUTES
} from "../actions/categories_actions";
import { ROUTES_CONST } from "../../utils/constants";


const initialState = {
  categories: [],
  routes: ROUTES_CONST,
  requestProgress: false,
  requestFailed: false,
}

export const categoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case CATEGORIES_REQUEST: {
      return {
        ...state,
        requestProgress: true,
        requestFailed: false
      }
    }
    case CATEGORIES_REQUEST_SUCCESS: {
      const filteredRoutes = action.routes.filter(newRoute => !state.routes.find(s_r => s_r.path === newRoute.path));
      return {
        ...state,
        categories: [...action.categories],
        routes: [...state.routes, ...filteredRoutes],
        requestProgress: false,
        requestFailed: false
      }
    }
    case CATEGORIES_REQUEST_FAILED: {
      return {
        ...state,
        requestProgress: false,
        requestFailed: true
      }
    }
    case CATEGORIES_ADD_ROUTES: {
      const filteredRoutes = action.routes.filter(newRoute => !state.routes.find(s_r => s_r.path === newRoute.path));
      return {
        ...state,
        routes: [...state.routes, ...filteredRoutes]
      }
    }
    default: return state;
  }
}
